import PeopleIcon from "@mui/icons-material/People";
import {
    CircularProgress,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { HistoryItem } from "@/queries/useFetchHistoryForCurrentUser.ts";
import { useFetchPersonByUUID } from "@/queries/useFetchPersonByUUID.ts";
import { dateTimeFormat } from "@/utils/dateFormats.ts";

type Props = {
    historyItem: HistoryItem;
};

const PersonHistoryItem = ({ historyItem }: Props) => {
    const [personUUID, setPersonUUID] = useState("");
    const navigate = useNavigate();

    const { data, isError, isRefetching, isLoading } = useFetchPersonByUUID({
        isQueryEnabled: personUUID !== "",
        personUUID: personUUID,
    });

    useEffect(() => {
        if (data?.data?.id) {
            navigate(`/person-detail/${data?.data.id}`);
        }
    }, [data?.data]);

    return (
        <ListItem key={historyItem.idUUID} disablePadding>
            <ListItemButton onClick={() => setPersonUUID(historyItem.idGlobalUUID ?? "")}>
                {historyItem.faicon && (
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                        <PeopleIcon sx={{ color: "grey" }} />
                    </ListItemIcon>
                )}
                <ListItemText
                    primary={historyItem.name}
                    secondary={
                        historyItem.metaModifiedWhen
                            ? dateTimeFormat.format(historyItem.metaModifiedWhen)
                            : ""
                    }
                />
                {(isLoading || isRefetching) && <CircularProgress size={"12px"} />}
                {isError && <Typography variant={"h5"}>Error loading documents</Typography>}
            </ListItemButton>
        </ListItem>
    );
};

export default PersonHistoryItem;
